import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_COLLECTION_ITEM } from '../actions';

import {
  createCollectionItemSuccess,
  createCollectionItemError
} from './actions';

const CREATE_COLLECTION_ITEM_ERROR = "Collection item create fails.";

const createCollectionItemAsync = async (newRecord, id) => {
  let dataReturned;
  try {
    dataReturned = id > 0 ? await centralApiAxios.put("nodes?id=" + id, newRecord) : await centralApiAxios.post("nodes", newRecord);
    if (dataReturned.data && dataReturned.data.nodeId > 0) {
      return {
        collectionItem: dataReturned.data,
        message: null,
      };
    }
    return { message: CREATE_COLLECTION_ITEM_ERROR };
  } catch (error) {
    return {
      message: CREATE_COLLECTION_ITEM_ERROR,
    };
  }
};

function* createCollectionItem({ payload }) {
  const { history } = payload;
  try {
    const resultReturned = yield call(createCollectionItemAsync, payload.newRecord, payload.id);
    if (!resultReturned.message) {
      yield put(createCollectionItemSuccess(resultReturned.collectionItem));
      history.push("/app/collectionitemoverview/" + resultReturned.collectionItem.nodeId);
      window.location.reload();
    } else {
      yield put(createCollectionItemError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(createCollectionItemError(CREATE_COLLECTION_ITEM_ERROR));
  }
}

export function* watchCreateCollectionItem() {
  yield takeEvery(CREATE_COLLECTION_ITEM, createCollectionItem);
}


export default function* rootSaga() {
  yield all([
    fork(watchCreateCollectionItem)
  ]);
}
